import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { SadhonaFormPage } from '../sadhona-form/sadhona-form';
import { ViewSadhanaPage } from '../view-sadhana/view-sadhana';
import { UserData } from '../../providers/user-data'
import { MenteeGroupData } from '../../providers/mentee-group-data'
import { ViewMenteeSadhanaPage } from '../view-mentee-sadhana/view-mentee-sadhana'
import { ViewMyMenteesPage } from '../view-my-mentees/view-my-mentees';
import { Storage } from '@ionic/storage';
import { CustomDatepickerPage } from '../custom-datepicker/custom-datepicker';
import { NotificationPage } from '../notification/notification';
import * as io from 'socket.io-client';
import { EmailSadhanaPage } from '../email-sadhana/email-sadhana';

@IonicPage()
@Component({
  selector: 'page-home',
  templateUrl: 'home.html',
})
export class HomePage {
  socket: any;
  mentees: any
  isMentor: boolean = false
  notifications: any;
  constructor(public navCtrl: NavController, public navParams: NavParams, private userData: UserData, private menteeGroupData: MenteeGroupData,
    private storage: Storage) {
    this.userData.checkAuth().subscribe(
      res => { }
    )
  }

  ionViewCanEnter() {
    // return this.userData.authenticated();
    // this.navCtrl.push(CustomDatepickerPage);
  }

  ionViewDidLoad() {
    console.log('new version loaded')
    this.storage.get('ismentor').then((value) => {
      this.isMentor = value
    });
    this.getNotification();

  }
  openPage(value) {
    if (value == 'sadhonaform') {
      this.navCtrl.push(SadhonaFormPage)
    } else if (value == 'viewallsadhona') {
      this.navCtrl.push(ViewSadhanaPage)
    } else if (value == 'ViewMyMenteesPage') {
      this.navCtrl.push(ViewMyMenteesPage)
    } else if (value == 'notification') {
      this.navCtrl.push(NotificationPage)
    } else if (value == 'emailsadhona') {
      this.navCtrl.push(EmailSadhanaPage)
    }

  }

  OnSelectDate(value) {
    console.log(value);
  }

  getNotification() {
    this.userData.getNotifications().subscribe(
      res => {
        this.notifications = res['data'];
        // for (let item of res['data']) {
        //   this.showNotification(item.notification);
        // }
      }
    )
  }

  showNotification(msg) {
    if (("Notification" in window)) {
      if ((Notification as any).permission === "granted") {
        // If it's okay let's create a notification
        new Notification(msg);
      } else if ((Notification as any).permission !== "denied") {
        Notification.requestPermission().then(function (permission) {
          // If the user accepts, let's create a notification
          if (permission === "granted") {
            new Notification(msg);
          }
        });
      }
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/home/home.ts